"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpJSONToTable = void 0;
const _ = __importStar(require("lodash"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const json_to_table_html_1 = __importDefault(require("./json-to-table.html"));
let ItpJSONToTable = class ItpJSONToTable extends vue_1.default {
    rows;
    unsub;
    json;
    truncateText;
    onJSONChange(newValue, oldValue) {
        if (this.unsub) {
            this.unsub();
        }
        this.unsub = this.$watch(() => newValue, this.updateRows);
        this.updateRows();
    }
    data() {
        return {
            rows: this.getRows()
        };
    }
    mounted() {
        if (this.unsub) {
            this.unsub();
        }
        this.unsub = this.$watch(() => this.json, this.updateRows);
    }
    updateRows() {
        this.rows = this.getRows();
    }
    truncated(value) {
        return value ? value.substring(0, this.truncateText) : value;
    }
    getRows() {
        return _.map(this.json, (value, field) => {
            const nested = _.isObject(value), truncate = !nested &&
                _.isString(value) &&
                value.length > this.truncateText, hasLineBreaks = !nested && _.isString(value) && value.includes('\n');
            return {
                field,
                value: _.isString(value) ? value.trim() : value,
                nested,
                isExpanded: false,
                truncate,
                tagName: hasLineBreaks ? 'pre' : 'span'
            };
        });
    }
};
exports.ItpJSONToTable = ItpJSONToTable;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], ItpJSONToTable.prototype, "json", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({}),
    __metadata("design:type", Number)
], ItpJSONToTable.prototype, "truncateText", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('json'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ItpJSONToTable.prototype, "onJSONChange", null);
exports.ItpJSONToTable = ItpJSONToTable = __decorate([
    (0, vue_property_decorator_1.Component)({ template: json_to_table_html_1.default })
], ItpJSONToTable);
//# sourceMappingURL=json-to-table.js.map